import { FC } from 'react'
import { MaskType } from '_metronic/helpers'
import { Input } from 'app/components/Input/Input'
import { CanalEnvio, PreferenciasEnvio } from '../../core/montagem/envio'
import styles from '../../Prescricao.module.scss'
import { CheckBox } from 'app/components'
import { useRotulos } from '../comum/useRotulos'
import { ID_EMAIL_ENVIO, ID_TELEFONE_ENVIO } from './ids'

type IProps = {
  preferencias: PreferenciasEnvio
  erros: { telefone?: boolean; email?: boolean }
  onChange: (preferencias: PreferenciasEnvio) => void
}

/** Para onde mandar os documentos depois de assinar; telefone e e-mail vêm do cadastro. */
export const SecaoEnvio: FC<IProps> = ({ preferencias, erros, onChange }) => {
  const { t } = useRotulos()
  const porTelefone = preferencias.whatsapp || preferencias.sms

  const marcar = (canal: CanalEnvio) => (
    <CheckBox
      id={`revisao-envio-${canal}`}
      label={t(`prescricao.envio.${canal}`)}
      checked={preferencias[canal]}
      onChange={(evento) => onChange({ ...preferencias, [canal]: evento.target.checked })}
    />
  )

  return (
    <section
      aria-labelledby='revisao-envio'
      className={`${styles.secao} d-flex flex-column gap-4 border-0`}
    >
      <div>
        <h3 id='revisao-envio' className='fs-6 fw-bold m-0'>
          {t('prescricao.envio.titulo')}
        </h3>
        <span className={`fs-7 ${styles.textoSecundario}`}>{t('prescricao.envio.explicacao')}</span>
      </div>

      <fieldset className='m-0 p-0 border-0 d-flex flex-column gap-2'>
        <legend className='fs-7 fw-semibold mb-1'>{t('prescricao.envio.por_telefone')}</legend>
        <div className='d-flex gap-5'>
          {marcar('whatsapp')}
          {marcar('sms')}
        </div>
        <label htmlFor={ID_TELEFONE_ENVIO} className='fs-7 fw-semibold'>
          {t('prescricao.envio.telefone')}{' '}
          <span className={`fw-normal ${styles.textoSecundario}`}>
            {t('prescricao.envio.do_cadastro')}
          </span>
        </label>
        <div className={styles.campoTelefone}>
          <Input
            id={ID_TELEFONE_ENVIO}
            mask={MaskType.Phone}
            value={preferencias.telefone}
            placeholder='(00) 0 0000-0000'
            disabled={!porTelefone}
            isInvalid={porTelefone && erros.telefone}
            errorMessage={t('prescricao.envio.telefone_invalido')}
            onChange={(evento) => onChange({ ...preferencias, telefone: evento.target.value })}
          />
        </div>
      </fieldset>

      <div className='d-flex flex-column gap-2'>
        {marcar('email')}
        <label htmlFor={ID_EMAIL_ENVIO} className='fs-7 fw-semibold'>
          {t('prescricao.envio.email')}{' '}
          <span className={`fw-normal ${styles.textoSecundario}`}>
            {t('prescricao.envio.do_cadastro')}
          </span>
        </label>
        <div className={styles.campoEstreito}>
          <Input
            id={ID_EMAIL_ENVIO}
            value={preferencias.enderecoEmail}
            placeholder={t('prescricao.envio.email_placeholder')}
            disabled={!preferencias.email}
            isInvalid={preferencias.email && erros.email}
            errorMessage={t('prescricao.envio.email_invalido')}
            onChange={(evento) => onChange({ ...preferencias, enderecoEmail: evento.target.value })}
          />
        </div>
      </div>
    </section>
  )
}
